/* global google, GMaps, MarkerClusterer */
import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on the Host an event paid search page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Hero Search Location Form Sticky top
    const $window = $(window);
    const $HeroContainerHeight = $('.hero-bg-container').height();
    const $HeroSearchLocationForm = $('.search-location-form');
    const $HeroSearchLocationFormWrapper = $HeroSearchLocationForm.closest('.form-wrapper');

    helpers.onWindowEvents(() => {
      const yPosition = $window.scrollTop();

      if (yPosition >= $HeroContainerHeight) {
        $HeroSearchLocationFormWrapper.addClass('sticky-top');
      } else {
        $HeroSearchLocationFormWrapper.removeClass('sticky-top');
      }
    }, 0, 0, 1, 1);

    const loadMap = function() {
      // Map
      const hotelsMapWrapper = $('#hotels-map-wrapper');
      if (hotelsMapWrapper.length) {
        const hotels = hotelsMapWrapper.data('hotels');

        if (hotels && hotels.length > 0) {
          const map = new GMaps({
            div: '#hotels-map-wrapper',
            scrollwheel: false,
            center: new google.maps.LatLng(hotels[0]['location']['lat'], hotels[0]['location']['lng']),
            zoom: 15,
            markerClusterer: function(map) {
              return new MarkerClusterer(map, null, {
                styles: [
                  {
                    textColor: 'white',
                    textSize: 20,
                    url: window.Rydges['assetsPath'] + 'images/map-markers/blank.svg',
                    height: 62,
                    width: 62,
                  },
                ],
              });
            },
          });

          const bounds = [];

          for (let i = 0; i < hotels.length; i++) {
            if (Object.keys(hotels[i]['location']).length > 0) {
              let mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();
              const title = hotels[i]['title'];
              const lat = hotels[i]['location']['lat'];
              const lng = hotels[i]['location']['lng'];
              const link = hotels[i]['link'];

              if (hotels[i]['discount_text'].length > 0) {
                mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window-with-discount').html();
              }

              bounds.push(new google.maps.LatLng(lat, lng));

              map.addMarker({
                lat: lat,
                lng: lng,
                title: title,
                icon: {
                  scaledSize: new google.maps.Size(44, 44),
                  url: window.Rydges['assetsPath'] + 'images/map-markers/default.svg',
                },
                infoWindow: {
                  content: helpers.transformMapMarkerInfoWindow({
                    title,
                    image: hotels[i]['images'][0],
                    address: hotels[i]['address'],
                    discount: hotels[i]['discount_text'],
                    link,
                  }, mapMarkerInfoWindowTemplate),
                },
              });
            }
          }

          if (hotels.length > 1) {
            map.fitLatLngBounds(bounds);
          }
        }
      }
    };

    // View types
    const hotelViewTypes = $('#hotel-view-types');
    if (hotelViewTypes.length) {
      const viewTypeItem = hotelViewTypes.find('.view-type-item');
      const viewTypeContent = $('.view-type-content');

      viewTypeItem.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const targetData = _this.data('target');
        const view = _this.data('view');
        const target = $(targetData);

        viewTypeItem.removeClass('active');
        _this.addClass('active');

        if (target.length) {
          viewTypeContent.hide();
          target.show();

          if (view === 'map') {
            loadMap();
          }
        }
      });
    }

    // Slides
    const hotelSlider = $('.section-paid-search-hotels .single-hotel-wrapper .slider');
    if (hotelSlider.length) {
      hotelSlider.each(function() {
        let _this = $(this);

        _this.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          swipe: false,
          mobileFirst: true,
          prevArrow: _this.parent('.preview-images').find('.prev'),
          nextArrow: _this.parent('.preview-images').find('.next'),
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHostEventPaidSearch.js